export default __webpack_public_path__ + "static/media/Frame 20.350b54ff.png";